export const parseFileExtension = (fileName = "") => {
    if (!fileName) return ""
    if (!fileName.match(/[^.]\w+$/i)) return ""
    return fileName.match(/[^.]\w+$/i)[0].toLowerCase()
}